import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logout } from 'logout';
import { automaticService } from 'services';

export const getAssemblyWorkOrders = createAsyncThunk(
    "getAssemblyWorkOrders",
    async ({
        startDate,
        endDate,
        productType,
        skip,
        limit,
        searchExp
    },
        { rejectWithValue }
    ) => {
        try {
            return await automaticService.getAssemblyWorkOrders(
                startDate,
                endDate,
                productType,
                skip,
                limit,
                searchExp
            );
        } catch (error) {
            if (error.message) {
                if (error?.response?.status === 401) {
                    logout()
                }
                //No response to request (No service)
                console.log("Internet Disconnected")
            } else {
                console.log(error);
                return (rejectWithValue)
            }
        }
    }
)


const initialState = {
    result: [
        {
            "firstModificationTime": "2024-10-22T14:29:00.710Z",
            "lastModificationTime": "2024-10-22T15:02:00.710Z",
            "assemblyCount": 4,
            "workOrderId": "0000004",
            "productTypes": [
                "ISPIRO"
            ]
        },
        {
            "firstModificationTime": "2024-10-22T14:28:00.710Z",
            "lastModificationTime": "2024-10-22T14:28:00.710Z",
            "assemblyCount": 1,
            "workOrderId": "0000003",
            "productTypes": [
                "ISPIRO"
            ]
        },
        {
            "firstModificationTime": "2024-10-22T14:27:00.710Z",
            "lastModificationTime": "2024-10-22T14:27:00.710Z",
            "assemblyCount": 1,
            "workOrderId": "0000002",
            "productTypes": [
                "ISPIRO"
            ]
        }
    ],
    loading: null,
    error: null
}

const assemblyWorkOrdersSlice = createSlice({
    name: "assemblyWorkOrders",
    initialState: initialState,
    reducers: {
        clearAssemblyWorkOrders: (state, _action) => {
            state.result = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAssemblyWorkOrders.pending, (state, _action) => {
            state.loading = true;
        });
        builder.addCase(getAssemblyWorkOrders.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action.payload;
            state.error = null;
        });
        builder.addCase(getAssemblyWorkOrders.rejected, (state, action) => {
            state.loading = false;
            state.result = null;
            state.error = action.payload;
        });
    },
})


export const { clearAssemblyWorkOrders } = assemblyWorkOrdersSlice.actions;

export default assemblyWorkOrdersSlice.reducer;